var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "center" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("TERMOS\n  DE USO E SERVIÇOS")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "center" }
      },
      [_c("font", { attrs: { color: "#000000" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Olá!\n  Que bom contar com seu interesse! Antes de usar nossos serviços,\n  tire um tempo para ler nossos Termos de Uso e Serviços e conhecer as\n  regras que regem nossa relação com você."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Abaixo\n  esclareceremos alguns pontos que julgamos importantes. Caso persista\n  alguma dúvida acerca de quaisquer pontos discutidos ou não neste\n  documento, ou ainda, caso queira dar sugestões ou relatar problemas,\n  por favor, não hesite em contatar-nos pelo endereço de e-mail:\n  "
                    ),
                    _c(
                      "font",
                      { attrs: { color: "#0000ff" } },
                      [
                        _c("font", { attrs: { face: "Arial" } }, [
                          _c("u", [
                            _c("b", [
                              _c(
                                "span",
                                { staticStyle: { background: "#ffffff" } },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:contato@donamaid.com"
                                      }
                                    },
                                    [_vm._v("contato@donamaid.com")]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(".")
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("1.\n  DAS DEFINIÇÕES:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "No\n  presente instrumento, entendemos as expressões abaixo de acordo com\n  as seguintes definições:"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [_vm._v("DONAMAID:\n  ")]),
                    _vm._v(
                      "DONAMAID TECNOLOGIA LTDA, sociedade empresarial de\n  responsabilidade limitada, inscrita no CNPJ sob o n°\n  28.052.325/0001-37, com sede na cidade de Pelotas/RS, na Rua\n  Gonçalves Chaves, n° 560, apto 201, Centro, CEP 96015-560. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(":\n  sistema constituído por uma aplicação "),
                    _c("i", [_vm._v("web")]),
                    _vm._v(" e "),
                    _c("i", [_vm._v("mobile")]),
                    _vm._v(",\n  oferecido por "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "e de propriedade, operação e\n  responsabilidade da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(", onde todos os "),
                    _c("b", [_vm._v("USUÁRIOS ")]),
                    _vm._v(
                      "podem\n  visualizar e utilizar os serviços oferecidos pela "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [_vm._v("SERVIÇOS:\n  ")]),
                    _vm._v("Os Serviços oferecidos através da "),
                    _c("b", [_vm._v("PLATAFORMA ")]),
                    _vm._v(
                      "integram um\n  portal de tecnologia que permite ao cliente (“USUÁRIO CLIENTE”)\n  encontrar e contratar serviços de limpeza e outros oferecidos por um\n  prestador de serviços autônomo (“USUÁRIO PRESTADOR”)\n  cadastrado na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(". O "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(" utiliza os\n  serviços da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" com o intuito de encontrar e contratar\n  um "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(". Em contrapartida, o "),
                    _c("b", [_vm._v("USUÁRIO\n  PRESTADOR")]),
                    _vm._v(" utiliza os Serviços da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " com o intuito\n  de divulgar suas informações profissionais e ser encontrado e\n  contratado pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      ". Os Serviços de informação\n  na internet oferecidos pela "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " permitem a realização\n  da referida busca e contratação por meio eletrônico, uma vez que\n  os serviços da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" facilitam a relação desejada entre\n  o "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(" e o "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [_vm._v("TRATAMENTO\n  DE DADOS:")]),
                    _vm._v(" Toda operação realizada pela "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" com os\n  dados pessoais do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      ", e mediante expresso consentimento\n  deste ao aceitar os presentes Termos, como as que se referem a\n  coleta, produção, recepção, classificação, utilização,\n  acesso, reprodução, transmissão, distribuição, processamento,\n  arquivamento, armazenamento, eliminação, avaliação ou controle da\n  informação, modificação, comunicação, transferência, difusão\n  ou extração. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("USUÁRIOS:\n  ")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("ol", { attrs: { type: "a" } }, [
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("b", [_vm._v("USUÁRIO\n    CLIENTE: ")]),
                        _vm._v("pessoa física ou jurídica cadastrada na "),
                        _c("b", [_vm._v("PLATAFORMA,")]),
                        _vm._v(
                          "\n    que acesse e/ou utilize os serviços ofertados pelos "
                        ),
                        _c("b", [_vm._v("USUÁRIOS\n    PRESTADORES ")]),
                        _vm._v("na"),
                        _c("b", [_vm._v(" PLATAFORMA")]),
                        _vm._v(".")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("ol", { attrs: { type: "a", start: "2" } }, [
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("b", [_vm._v("USUÁRIO\n    PRESTADOR:")]),
                        _vm._v(" pessoa física ou jurídica cadastrada na "),
                        _c("b", [_vm._v("PLATAFORMA")]),
                        _vm._v(
                          ",\n    que no uso desta irá ofertar os seus serviços aos "
                        ),
                        _c("b", [_vm._v("USUÁRIOS\n    CLIENTES")]),
                        _vm._v(
                          ", bem como fará uso de seu Aplicativo Específico para\n    gestão de seus serviços. "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("2.\n  DA ADESÃO:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Este\n  instrumento regula as condições de uso dos serviços da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(",\n  sendo um contrato entre os "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" e a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-top": "0.28cm",
          "margin-bottom": "0cm",
          "line-height": "100%"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "Este\n  documento visa registrar a manifestação livre, informada e\n  inequívoca pela qual o Titular concorda com o tratamento de seus\n  dados pessoais para finalidade específica, em conformidade com a Lei\n  nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD)."
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-top": "0.28cm",
          "margin-bottom": "0cm",
          "line-height": "100%"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "Ao\n  manifestar sua aceitação para com o presente termo, o usuário\n  indica expressamente que concorda com os termos e condições\n  contidos neste instrumento e com as disposições legais aplicáveis\n  à espécie. "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-top": "0.28cm",
          "margin-bottom": "0cm",
          "line-height": "100%"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_vm._v("Uma\n  vez cadastrado, o ")]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("USUÁRIO")])]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "\n  poderá, a qualquer tempo, por meio de ferramenta oferecida no\n  Aplicativo e/ou no Website, revisar e alterar suas informações de\n  cadastro."
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-top": "0.28cm",
          "margin-bottom": "0cm",
          "line-height": "100%"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_vm._v("O\n  aceite do ")]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("USUÁRIO")])]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_vm._v("\n  também autoriza a ")]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("DONAMAID")])]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "\n  a elaborar relatórios sobre os contratos e/ou os outros documentos\n  assinados e disponibilizar estes relatórios ao Usuário e/ou aos\n  demais signatários."
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " trabalha com uma rede de parceiros, de modo a\n  fornecer ao usuário conteúdo útil e em seu benefício, mediante a\n  sua expressa autorização dada ao aceitar ao final os presentes\n  Termos, em consonância com a previsão legal do art. 10, II, da Lei\n  13.709/18. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Deste\n  modo, o usuário concorda expressamente em receber da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ":\n  (i) anúncios de terceiros dentro do aplicativo e do "
                    ),
                    _c("i", [_vm._v("website")]),
                    _vm._v(
                      "\n  (ii) amostras grátis de produtos de estabelecimentos parceiros e\n  (iii) links para compras dentro do aplicativo de produtos fornecidos\n  por terceiros."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" reconhece que a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " não é fornecedora\n  de bens e não presta serviços de limpeza ou cuidados em geral, nem\n  funciona como terceirizadora de serviços, e que todos os serviços\n  de limpeza e cuidados em geral são prestados por "
                    ),
                    _c("b", [_vm._v("USUÁRIOS\n  PRESTADORES")]),
                    _vm._v(
                      " independentes que não são empregados (as) e nem\n  representantes da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " apenas cobra uma taxa de utilização dos usuários\n  prestadores para cada contratação realizada pelos usuários\n  clientes. Essa taxa de utilização é cobrada de forma automática\n  no momento em que o "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" recebe o preço pago\n  pelo usuário cliente. ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("\n  Caso\n  o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " NÃO CONCORDE com os termos previstos neste\n  instrumento, basta não clicar na caixa que será disponibilizada ao\n  final, onde o "
                    ),
                    _c("b", [_vm._v("USUÁRIO ")]),
                    _vm._v(
                      "declara expressamente estar de acordo\n  com os termos de uso."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("3.\n  QUEM SOMOS E O QUE FAZEMOS:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("A ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID\n  ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("é uma empresa privada,\n  que oferece uma ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  constituída por uma aplicação ")
                    ]),
                    _c("i", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("web")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  e ")
                    ]),
                    _c("i", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("mobile")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  disponível na Google Play, que aproxima os ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(".\n  Nela os ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS\n  CLIENTES")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        " consentem em\n  informar a sua localidade, bem como o número de horas de limpeza,\n  contando com o auxílio de uma calculadora de simulação, onde\n  deverá ser informado o número de cômodos/itens para estimação da\n  quantidade de horas de limpeza necessária."
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("4.\n  DAS CONDIÇÕES GERAIS DE USO:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("apenas é uma "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" que conecta os\n  "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      ", sendo a sua responsabilidade restrita apenas ao\n  funcionamento correto da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA ")]),
                    _vm._v(
                      "e de suas funcionalidades,\n  conforme este instrumento. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Na\n  relação entre "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(" e a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" ou entre\n  "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" e a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(", a "),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v(
                      "reserva-se o direito de estabelecer, remover e/ou revisar o Preço\n  relativo a todos os serviços de limpeza e cuidados em geral obtidos\n  por meio do uso da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " e dos Serviços a qualquer\n  momento, a critério exclusivo da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ". Ademais, você\n  reconhece e concorda que o preço aplicável em certas áreas\n  geográficas poderá variar e/ou aumentar substancialmente quando a\n  oferta de limpezas e cuidados em geral por parte dos "
                    ),
                    _c("b", [_vm._v("USUÁRIOS\n  PRESTADORES")]),
                    _vm._v(
                      " for menor do que a demanda por limpezas e cuidados em\n  geral. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  tempo escolhido para a contratação do "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" é\n  de responsabilidade exclusivamente do "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(", e\n  qualquer indicação de tempo por parte da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" ou dos\n  "),
                    _c("b", [_vm._v("USUÁRIOS PRESTADORES")]),
                    _vm._v(
                      " é meramente uma SUGESTÃO com base em\n  históricos de "
                    ),
                    _c("b", [_vm._v("USUÁRIOS CLIENTES")]),
                    _vm._v(" anteriores. A "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      "\n  não tem nenhuma responsabilidade pela insuficiência de tempo ou\n  incompletude dos dados disponibilizados. Caso a insuficiência de\n  tempo ou incompletude dos dados fornecidos pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v("\n  impossibilite que o "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      " conclua todo o serviço\n  de limpeza desejado dentro do tempo escolhido pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  CLIENTE")]),
                    _vm._v(", o "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " assume a culpa exclusiva pela\n  não conclusão do serviço desejado dentro do tempo escolhido,\n  isentando nestes casos a "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" e o "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v("\n  de toda e qualquer responsabilidades.\n  ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("não detém nenhuma relação com os "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADORES ")]),
                    _vm._v("cadastrados, não sendo possível imputar à\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "a responsabilidade por qualquer dano causado aos\n  "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTES")]),
                    _vm._v(" ou a terceiros, por atos oriundos\n  dos "),
                    _c("b", [_vm._v("PRESTADORES DE SERVIÇOS ")]),
                    _vm._v(
                      "no momento da prestação dos\n  serviços intermediados através"
                    ),
                    _c("b", [_vm._v(" PLATAFORMA")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c("a", { attrs: { name: "_gjdgxs" } }),
        _vm._v(" "),
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("Ainda,\n  a ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  não pode ser responsabilizada por serviços realizados entre os\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  da ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  acertados entre os próprios ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  de forma que a ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  orienta que aos ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  não troquem informações pessoais de telefone com fito de contratar\n  os serviços por fora da "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(".")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("A\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  aconselha que os serviços contratados sejam realizados por meio da\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  disponibilizada pela ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  de forma que esta mantenha em sua base de ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  apenas pessoas qualificadas, gerando maior credibilidade e segurança\n  para os "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(".")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("É\n  de responsabilidade dos "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      " terem e manterem\n  equipamentos e estruturas que respeitem os requisitos mínimos para a\n  utilização dos serviços oferecidos pela "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("5.\n  DO CADASTRO:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Os\n  serviços oferecidos pela "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "estão disponíveis para\n  pessoas físicas absolutamente capazes e pessoas jurídicas\n  devidamente inscritas no CNPJ. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Para\n  os "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" pessoa física realizarem o seu cadastro na\n  "),
                    _c("b", [_vm._v("PLATAFORMA, ")]),
                    _vm._v("eles fornecerão à "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "os seguintes\n  dados: Nome, sobrenome, data de nascimento, CPF, telefone celular,\n  cidade, endereço de e-mail e senha. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [_c("font", { attrs: { color: "#000000" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Para\n  os "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" pessoa jurídica realizarem o seu cadastro na\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(", eles fornecerão à "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " os seguintes\n  dados: CNPJ, nome fantasia, razão social, endereço de e-mail, senha\n  e dados do seu representante: Nome, sobrenome, data de nascimento,\n  CPF, telefone celular e endereço completo (Rua, número,\n  complemento, bairro, cidade e CEP)."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  coleta dos dados dos "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      ", mediante seu expresso\n  consentimento, tem a finalidade de identificá-lo, bem como\n  habilitá-lo ao correto uso da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(", e, com isto, a\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "poderá assegurar a boa qualidade das funcionalidades\n  da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", atendendo ao legítimo interesse da DONAMAID e\n  em benefício do USUÁRIO. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Ao\n  consentir com os termos do presente instrumento, os "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      "\n  declaram expressamente estar cientes que a coleta dos seus dados é\n  primordial para o bom funcionamento da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA, ")]),
                    _vm._v(
                      "e que serão\n  utilizados respeitando as normas previstas na Lei Geral de Proteção\n  de Dados.  "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "É\n  expressamente vedada a criação de mais de um cadastro por "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  ")]),
                    _vm._v("na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ". Em caso de multiplicidade de cadastros\n  elaborados por um só "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(", a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "se reserva o\n  direito de, ao seu exclusivo critério, sem contrapartida\n  indenizatória e sem necessidade de prévia anuência ou comunicação,\n  inabilitar todos os cadastros existentes em nome deste "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      ",\n  podendo não aceitar novo cadastro do referido "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" na"),
                    _c("b", [_vm._v("\n  PLATAFORMA")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "É\n  necessário o preenchimento completo de todos os dados solicitados\n  pela "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" no momento do cadastramento, para que os\n  "),
                    _c("b", [_vm._v("USUÁRIOS ")]),
                    _vm._v("estejam habilitados a utilizar a "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("É\n  de exclusiva responsabilidade dos "),
                    _c("b", [_vm._v("USUÁRIOS ")]),
                    _vm._v(
                      "fornecer,\n  atualizar e garantir a veracidade dos dados cadastrais, não recaindo\n  à"
                    ),
                    _c("b", [_vm._v(" DONAMAID ")]),
                    _vm._v(
                      "qualquer tipo de responsabilidade civil e criminal\n  resultante de dados inverídicos, incorretos ou incompletos\n  fornecidos pelos "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Sendo\n  permitido aos "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" requisitar à "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ", a\n  correção de dados incompletos, inexatos ou desatualizados, mediante\n  fornecimento pelos "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("\n  A"),
                    _c("b", [_vm._v("\n  DONAMAID ")]),
                    _vm._v(
                      "se reserva o direito de utilizar todos os meios válidos\n  e possíveis para identificar seus "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      ", bem como de\n  solicitar dados adicionais e documentos que estime serem pertinentes\n  a fim de conferir os dados informados. Neste caso, o uso da\n  "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" pelo "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " fica condicionado ao envio dos\n  documentos e dos dados eventualmente solicitados. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "A\n  solicitação de dados adicionais, atenderá à finalidade\n  específica, consentida pelo titular."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" acessará a sua conta na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" por meio\n  de "),
                    _c("i", [_vm._v("login")]),
                    _vm._v(
                      " e senha, comprometendo-se a não informar a terceiros\n  estes dados, responsabilizando-se integralmente pelo uso que deles\n  seja feito."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("O\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  poderá ter acesso às informações coletadas e tratadas pela\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  de forma gratuita, através do ")
                    ]),
                    _c("i", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("link")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  https://cliente.donamaid.com/meus-dados ou através da sua conta na\n  Plataforma, podendo editá-las ou excluí-las a qualquer tempo. "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" compromete-se a notificar a "),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v(
                      "imediatamente, por meio dos canais de contato mantidos pela\n  "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", a respeito de qualquer uso não\n  autorizado de sua conta. O "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " será o único responsável\n  pelas operações efetuadas em sua conta, uma vez que o acesso só\n  será possível mediante a utilização de senha de seu exclusivo\n  conhecimento."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" compromete-se a notificar a "),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v(
                      "imediatamente, por meio dos canais de contato mantidos pela\n  "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", a respeito de qualquer\n  conhecimento de irregularidades de outros "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" que possam\n  ocasionar danos aos próprios "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" da "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(",\n  a esta, a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("ou a terceiros. ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Em\n  nenhuma hipótese será permitida a cessão, a venda, o aluguel ou\n  outra forma de transferência da conta do "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  apelido que o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" utiliza na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" não\n  poderá guardar semelhança com o nome "),
                    _c("b", [_vm._v("DONAMAID, ")]),
                    _vm._v(
                      "tampouco\n  poderá ser utilizado qualquer apelido que insinue ou sugira que os\n  serviços serão prestados pela "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Ao\n  seu exclusivo critério a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "poderá excluir,\n  inabilitar, suspender, bloquear, por tempo indeterminado, sem aviso\n  prévio ou contrapartida indenizatória, cadastros de "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      "\n  que sejam considerados ofensivos, que infrinjam os termos deste\n  instrumento ou a legislação em vigor."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "se reserva ao direito de não permitir novo cadastro\n  de "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      " que já tenham sido cancelados, inabilitados,\n  bloqueados, excluídos ou suspensos da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ". Não se\n  permitirá, ainda, a criação de novos cadastros por pessoas cujos\n  cadastros originais tenham sido cancelados, bloqueados, inabilitados,\n  excluídos ou suspensos por infrações às políticas da "
                    ),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v("ou a legislação vigente.")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "se reserva o direito de, unilateralmente, sem prévio\n  aviso, anuência ou contrapartida indenizatória, recusar qualquer\n  solicitação de cadastro de um "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" na "),
                    _c("b", [_vm._v("PLATAFORMA, ")]),
                    _vm._v(
                      "bem\n  como cancelar, inabilitar, bloquear, excluir ou suspender o uso de um\n  cadastro previamente aceito."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("\n  Para\n  se cadastrar como "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v("na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(",\n  deve o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" preencher o formulário solicitado pela\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" em "),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://donamaid.com/seja-diarista"
                            }
                          },
                          [_vm._v("https://donamaid.com/seja-diarista")]
                        )
                      ])
                    ]),
                    _vm._v(",\n  onde irá informar a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ",  suas referências\n  profissionais, comprovante de residência, cópia frente e verso do\n  documento de identificação, bem como demais documentos solicitados\n  pela própria "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" ou pela equipe da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".\n  Após o recebimento do e-mail a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("informará a\n  validação, ou não, do cadastro do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" como "),
                    _c("b", [_vm._v("PRESTADOR\n  DE SERVIÇO")]),
                    _vm._v(", "),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "no prazo de até\n  72 (setenta e duas) horas úteis."
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Os\n  dados fornecidos pelo "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", serão tratados\n  mediante seu expresso consentimento, com a finalidade específica de\n  serem utilizados para a correta prestação dos serviços constantes\n  nestes termos, incluindo a análise de antecedentes ("
                    ),
                    _c("i", [_vm._v("background\n  check")]),
                    _vm._v(
                      "), eis que referida análise é necessária para a correta\n  execução do contrato, atendendo ao legítimo interesse da "
                    ),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v("e dos próprios"),
                    _c("b", [_vm._v(" USUÁRIOS")]),
                    _vm._v(
                      ", respeitando o direito à\n  privacidade e intimidade do titular dos dados, nos termos previstos\n  na Lei Geral de Proteção de Dados. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Após\n  a validação e a liberação do cadastro de um "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v("na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" pela equipe da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(",\n  o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR, ")]),
                    _vm._v(
                      "começará, mediante sua\n  concordância, a receber notificações em seu Aplicativo Específico,\n  sobre os serviços solicitados de compras efetuadas na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" pelo "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [_c("font", { attrs: { color: "#000000" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  validação, ou não, de um "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v("na\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(", compete exclusivamente a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ", que se\n  reserva ao direito de recusar, a seu exclusivo critério, o cadastro\n  de algum "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("6.\n  DAS FUNCIONALIDADES:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Após\n  a realização de cadastro pelo "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(", a\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " disponibiliza formulário de agendamento de limpeza\n  a ser preenchida por este, onde serão informados o local da faxina,\n  o horário, a data e as características dos serviços de que\n  necessita, podendo ser mais de 01 (um). "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " escolherá a data da faxina preferencialmente\n  em dias úteis, ou, ainda, dias alternativos disponibilizados pelo\n  "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", assim como o horário de início da faxina\n  pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", a qual terá o limite diário de 1\n  (uma) a 8 (oito) horas de duração, podendo ser entre as 7h e 20h de\n  acordo com sua necessidade informada na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" irá sugerir "),
                    _c("b", [_vm._v("USUÁRIOS PRESTADORES")]),
                    _vm._v(" de acordo\n  com a localidade do "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      ", podendo o mesmo escolher\n  o profissional autônomo pesquisando pelo nome do "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  PRESTADOR,")]),
                    _vm._v(
                      " ou a partir das avaliações anteriores de limpezas\n  realizadas pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("No\n  valor da limpeza a ser realizada pelo "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" estão\n  inclusos: "),
                    _c("b", [_vm._v("(i)")]),
                    _vm._v(" o serviço prestado, "),
                    _c("b", [_vm._v("(ii)")]),
                    _vm._v(" os produtos de\n  limpeza, "),
                    _c("b", [_vm._v("(iii)")]),
                    _vm._v(" transporte e "),
                    _c("b", [_vm._v("(iv)")]),
                    _vm._v(" alimentação do\n  "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR. ")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Os\n  itens e produtos de limpeza que cada "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v("\n  utiliza pode variar de cada "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(", porém, todos\n  os "),
                    _c("b", [_vm._v("USUÁRIOS PRESTADORES")]),
                    _vm._v(
                      " levam uma quantidade mínima de itens\n  e produtos de limpeza que constam na lista disponível no site da\n  "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ". A lista de produtos mínimos incluídos não\n  constam: baldes, escadas, rodos e vassouras, por exemplo, sendo\n  constantemente atualizada no site da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v("\n  ("),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c("a", { attrs: { href: "https://donamaid.com/" } }, [
                          _vm._v("https://donamaid.com/")
                        ])
                      ])
                    ]),
                    _vm._v(").")
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " poderá sugerir o uso ou não uso de\n  determinado item ou produto de limpeza levado pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  PRESTADOR")]),
                    _vm._v(
                      ", ou, ainda, poderá sugerir o uso de seus itens ou\n  produtos de limpeza de acordo com sua preferência, como aspirador de\n  pó, baldes, escadas, vassouras, ou qualquer outro que não consta na\n  lista disponibilizada pela "
                    ),
                    _c("b", [_vm._v("DONAMAID, ")]),
                    _vm._v(
                      "bem como a quantidade de\n  produtos descrito na lista,  bastando preencher as instruções no\n  campo destinado ao agendamento na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" ou comunicar ao\n  "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" no momento da faxina. ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Após\n  o preenchimento do formulário e a confirmação do agendamento da\n  faxina na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" pelo "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(", o "),
                    _c("b", [_vm._v("USUÁRIO\n  CLIENTE")]),
                    _vm._v(
                      " receberá em seu e-mail cadastrado a confirmação do seu\n  pedido. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("As\n  compras realizadas pelo "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " entre às 9h e as 18h\n  podem ser agendadas para o mesmo dia, desde que iniciem 2 (duas)\n  horas após a efetivação da compra na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(". Fora deste\n  prazo, o "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " só poderá agendar limpezas para o\n  próximo dia a partir das 9h da manhã. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(" poderá solicitar a escolha com o mesmo\n  "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      " o qual tenha gostado da prestação do\n  serviço por meio da busca do nome do "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(" no\n  fluxo de escolha dentro da "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", ou optar pela\n  modalidade de assinatura de limpezas periódicas com este "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  PRESTADOR")]),
                    _vm._v(", devendo acessar o link de assinatura\n  "),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c(
                          "a",
                          {
                            attrs: { href: "https://donamaid.com/assinatura/" }
                          },
                          [_vm._v("https://donamaid.com/assinatura/")]
                        )
                      ])
                    ]),
                    _vm._v(",\n  ou entrar em contato com o suporte da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" em seus canais\n  de comunicação na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(".")
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("No\n  uso das funcionalidades da "),
                    _c("b", [_vm._v("PLATAFORMA, ")]),
                    _vm._v("o"),
                    _c("b", [_vm._v(" USUÁRIO")]),
                    _vm._v("\n  compreende que não é permitido: "),
                    _c("b", [_vm._v("(i) ")]),
                    _vm._v(
                      "usar linguajar de baixo\n  calão, ofensivo ou com sentido dúbio; "
                    ),
                    _c("b", [_vm._v("(ii) ")]),
                    _vm._v(
                      "realizar\n  comentários difamatórios, contra qualquer pessoa física (viva ou\n  falecida) ou jurídica; "
                    ),
                    _c("b", [_vm._v("(iii) ")]),
                    _vm._v(
                      "realizar comentários ou\n  publicar imagens que possam infringir direitos de terceiros, sejam\n  contrários à moral e aos bons costumes, que incitem a violência, o\n  ódio, o sexismo, o racismo, que façam alusão a pornografia,\n  pedofilia, armas, drogas e demais conteúdos perturbadores ou\n  ilegais; "
                    ),
                    _c("b", [_vm._v("(iv) ")]),
                    _vm._v(
                      "enviar ou solicitar dados pessoais, tais como,\n  mas não se limitando a: e-mail, telefone, perfil do Facebook, perfil\n  do Instagram, contato no WhatsApp, links diversos, informações de\n  conta bancária, informações de documentos pessoais ou qualquer\n  outro meio de comunicação pessoal; "
                    ),
                    _c("b", [_vm._v("(v) ")]),
                    _vm._v(
                      "fazer menção à\n  alguma plataforma concorrente ou combinar o fechamento do negócio\n  por outro meio diverso da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v("; "),
                    _c("b", [_vm._v("(vi) ")]),
                    _vm._v(
                      "publicar\n  imagens contendo dados pessoais como telefones de contato, e-mail,\n  etc."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c("font", { attrs: { color: "#ff0000" } }, [
              _c("span", { staticStyle: { "text-decoration": "none" } })
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("Ao\n  final de cada limpeza, o ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PRESTADORES e o USUÁRIO\n  CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(" poderão\n  avaliar um ao outro mutuamente  na ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  , sobre o serviço realizado, podendo conferir uma nota de 0 a 5,\n  sendo esta avaliação pública para todos os outros "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  da ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        ".\n  Quando da avaliação, as mesmas serão publicadas na "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  sem a identificação de quem procedeu a avaliação.. A "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID\n  ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "procederá com o\n  monitoramento e publicação das avaliações realizadas pelos\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS,")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  buscando manter na ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS CLIENTES")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  e ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS PRESTADORES")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  qualificados.  ")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " poderá, a seu exclusivo critério, criar códigos\n  promocionais que poderão ser resgatados para crédito na conta ou\n  outras características ou benefícios para os "
                    ),
                    _c("b", [_vm._v("USUÁRIOS CLIENTES")]),
                    _vm._v(
                      ",\n  relacionados aos serviços e/ou a serviços do "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ",\n  sujeitos a quaisquer condições adicionais que sejam estabelecidas\n  para cada um dos códigos promocionais."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" compreende que os códigos promocionais: "),
                    _c("b", [_vm._v("(i)")]),
                    _vm._v(
                      "\n  devem ser usados de forma legal para a finalidade e o público a que\n  se destinam; "
                    ),
                    _c("b", [_vm._v("(ii)")]),
                    _vm._v(" poderão ser desabilitados pela "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      "\n  a qualquer momento por motivos legalmente legítimos, sem que disto\n  resulte qualquer responsabilidade; "
                    ),
                    _c("b", [_vm._v("(iii)")]),
                    _vm._v(
                      " somente poderão ser\n  usados de acordo com as condições específicas que a "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v("\n  estabelecer para esse Código Promocional; "),
                    _c("b", [_vm._v("(iv)")]),
                    _vm._v(" não são\n  válidos como dinheiro; e "),
                    _c("b", [_vm._v("(v)")]),
                    _vm._v(" poderão expirar antes de serem\n  usados. A "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " se reserva no direito de reter ou deduzir\n  créditos ou outras funcionalidades ou vantagens obtidas por meio do\n  uso dos Códigos Promocionais por você ou por outro "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  CLIENTE")]),
                    _vm._v(" ou "),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(", caso a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      "\n  apure ou acredite que o uso ou resgate do Código Promocional foi\n  feito com erro, fraude, ilegalidade ou violação às condições do\n  respectivo Código Promocional. Eventuais Promoções podem afetar o\n  preço final para a contratação de um "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v("\n  através dos Serviços da "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ". Caso realizadas, essas\n  promoções têm caráter temporário, transitório e não\n  vinculante."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" autoriza a "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " a lhe enviar pesquisas de\n  conhecimento/satisfação, relacionadas aos serviços e/ou a serviços\n  do "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", do aplicativo, da própria DONAMAID ou\n  para avaliação das amostras de parceiros enviadas em benefício do\n  próprio "
                    ),
                    _c("b", [_vm._v("USUÁRIO.")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [
                      _vm._v("7.\n  DAS OBRIGAÇÕES DOS USUÁRIOS PRESTADORES:")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Cabe\n  unicamente ao "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v("emitir"),
                    _c("b"),
                    _vm._v(
                      "nota\n  fiscal, ou recibo competente, dos serviços prestados ao "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v(
                      "cadastrado declara que detém\n  capacidade legal e técnica para prestar o serviço ofertado na\n  "
                    ),
                    _c("b", [_vm._v("PLATAFORMA, ")]),
                    _vm._v("bem como"),
                    _c("b"),
                    _vm._v(
                      "declara que é o único\n  responsável por todo e qualquer serviço que realize e que tenha\n  sido intermediado através da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Ainda,\n  o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR ")]),
                    _vm._v(
                      "fica responsável por qualquer\n  dano ocasionado ao "
                    ),
                    _c("b", [_vm._v("USUARIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(
                      " ou a terceiros,\n  pelos serviços que, porventura, mesmo que contatado para a\n  realização, através da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", deixe de prestar ou que\n  seja prestado em desacordo com o que fora acertado entre as partes. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "não se responsabiliza pelas obrigações tributárias\n  ou trabalhistas que recaiam sobre as atividades exercidas pelos\n  "
                    ),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADORES.")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [
                      _vm._v("8.\n  DAS OBRIGAÇÕES DOS USUÁRIOS CLIENTES:")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Cabe\n  unicamente ao "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(" exigir nota fiscal, ou\n  recibo competente, do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE ")]),
                    _vm._v(
                      "compreende que é de sua responsabilidade,\n  assim como de seu representante caso o informe na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ",\n  de estar presente na data e local agendada com o "
                    ),
                    _c("b", [_vm._v("USUÁRIO\n  PRESTADOR ")]),
                    _vm._v(
                      "para o serviço de limpeza, declarando estar ciente de\n  que a "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" não tem nenhum vínculo com o "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADOR")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " compreende que deve agendar limpezas em\n  horários em que possa aguardar por até 15 (quinze) minutos a mais\n  no início e no fim da limpeza, para eventuais atrasos (e\n  compensações de atrasos) inferiores a 15 (quinze) minutos por parte\n  dos "
                    ),
                    _c("b", [_vm._v("USUÁRIOS PRESTADORES.")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " compreende que não é preciso estar em casa\n  no momento da limpeza pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", devendo, para\n  isto, avisar a sua ausência no formulário de agendamento do serviço\n  na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA. ")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " compreende que, caso precise se ausentar do\n  local durante a limpeza pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR")]),
                    _vm._v(
                      ", deverá\n  deixar ao menos uma saída aberta para o "
                    ),
                    _c("b", [_vm._v("USUÁRIO PRESTADOR, ")]),
                    _vm._v(
                      "para\n  que o mesmo possa sair em caso de acidentes. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("CLIENTE")]),
                    _vm._v(
                      " compreende que é o único responsável\n  pelo acompanhamento do desenvolvimento dos serviços a serem\n  prestados pelos "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" "),
                    _c("b", [_vm._v("PRESTADORES.")])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("9.\n  MÉTODOS DE PAGAMENTO:")
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("Para\n  o pagamento dos serviços solicitados na ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  deverá o ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(" CLIENTE ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("escolher\n  por um dos métodos a seguir:")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("ol", { attrs: { type: "a" } }, [
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito VISA; ou,")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito MASTERCARD; ou,")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito AMERICAN EXPRESS; ou,")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito HIPERCARD; ou,")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito ELO; ou")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Cartão\n    de Crédito DINERS; ou, ")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Boleto\n    Bancário.")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "Para\n  utilizar o pagamento por meio de boleto bancário, o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO\n  CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        " compreende que o\n  agendamento do serviço de limpeza deve ser feito na "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  com pelo menos 2 (dois) dias úteis de antecedência à data\n  escolhida."
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "Para\n  processar os pagamentos através de cartão de crédito, será\n  necessário que o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(" CLIENTE ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("cadastre")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } })
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("na")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("\n  PLATAFORMA ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("os seguintes\n  dados do cartão escolhido:")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("ol", { attrs: { type: "a" } }, [
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Nome\n    do titular do Cartão de Crédito; ")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("CPF\n    do titular do Cartão de Crédito; ")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "Data de nascimento\n    do titular do Cartão de Crédito; "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Número\n    do Cartão de Crédito;")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Número\n    de Telefone do titular;")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "Vencimento\n    do Cartão de Crédito (Mês e Ano);"
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "Número\n    de segurança do Cartão de Crédito."
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("Caso\n  o ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  efetue o pagamento utilizando um cartão de crédito, receberá um\n  e-mail confirmando o seu pagamento. Em caso de recusa do pagamento, o\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  será imediatamente informado, na própria tela de pagamento. Em caso\n  de recusa, se o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO\n  CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        " ainda estiver\n  dentro do tempo máximo para pagamento, o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO\n  CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        " poderá tentar\n  utilizar um outro cartão de crédito ou corrigir os dados. Em não\n  estando mais dentro do tempo máximo para pagamento, o agendamento\n  dos serviços será cancelado, podendo o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO\n  CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        " realizar um novo\n  agendamento ou entrar em contato com o suporte da "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  através do e-mail ")
                    ]),
                    _c("u", [
                      _c(
                        "a",
                        { attrs: { href: "mailto:contato@donamaid.com" } },
                        [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("contato@donamaid.com")]
                          )
                        ]
                      )
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(".")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "Os\n  pagamentos são processados através da plataforma WIRECARD BRASIL\n  S.A., sendo necessário que todos os "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  também leiam e aceitem os termos de uso e serviços da plataforma\n  WIRECARD BRASIL S.A. através do endereço eletrônico:\n  "
                      )
                    ]),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://wirecard.com.br/contrato/"
                              }
                            },
                            [_vm._v("https://wirecard.com.br/contrato/")]
                          )
                        ])
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(".\n  ")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("A\n  contratação de qualquer ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(" PRESTADOR ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("feita\n  pelo ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(" CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        ",\n  com pagamento através de cartão de crédito, indica expressamente\n  que o "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v(" CLIENTE")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  leu e aceitou todas as condições presentes neste instrumento e nos\n  termos de uso e serviços específicos da plataforma WIRECARD BRASIL\n  S.A..  "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c("font", { attrs: { color: "#000000" } }, [
          _c("span", { staticStyle: { background: "#ffffff" } })
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "Qualquer\n  contestação de pagamentos efetuados através da plataforma WIRECARD\n  BRASIL S.A. deverá ser resolvida somente entre os "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  e a WIRECARD BRASIL S.A., não recaindo à ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID\n  ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "qualquer\n  responsabilidade pelo processamento dos pagamentos efetuados junto à\n  plataforma WIRECARD BRASIL S.A.. "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "A\n  plataforma WIRECARD BRASIL S.A. poderá cobrar taxas pela sua\n  utilização, cabendo somente ao "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  se informar acerca dos valores praticados pela WIRECARD BRASIL S.A.."
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("O\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  concorda que seus dados de pagamento fornecidos à "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(",\n  poderão ser salvos na base de dados desta")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } })
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("e da ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("WIRECARD\n  BRASIL S.A.")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(", podendo o\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  requerer a exclusão de seus dados, após a efetivação da\n  transação, devendo, para tanto, informar, quando solicitado pela\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        ",\n  que os dados de pagamento serão utilizados somente naquela\n  transação, não sendo necessários serem salvos para transações\n  posteriores. "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("A\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "somente\n  se responsabiliza por deletar os dados de pagamento fornecidos pelo\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  de sua própria base de dados, declarando o ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIO")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  estar ciente de que não compete à ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID\n  ")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "promover a exclusão dos\n  referidos dados da base de dados da WIRECARD BRASIL S.A."
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("10.\n  CANCELAMENTO E REMARCAÇÕES:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("10.1.\n  USUÁRIO CLIENTE")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c("font", {
                  staticStyle: { "font-size": "11pt" },
                  attrs: { size: "2" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTE")]),
                    _vm._v(
                      " pode cancelar ou remarcar o agendamento da\n  prestação do serviço entrando em contato com a "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " em\n  horário comercial pelos canais válidos, quais sejam: "
                    ),
                    _c("b", [_vm._v("(i)")]),
                    _vm._v("\n  telefones informados no website ("),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c(
                          "a",
                          { attrs: { href: "http://www.donamaid.com/" } },
                          [_vm._v("www.donamaid.com")]
                        )
                      ])
                    ]),
                    _vm._v(")\n  ou "),
                    _c("b", [_vm._v("(ii)")]),
                    _vm._v(" o e-mail "),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c(
                          "a",
                          { attrs: { href: "mailto:contato@donamaid.com" } },
                          [_vm._v("contato@donamaid.com")]
                        )
                      ])
                    ]),
                    _vm._v(
                      ",\n  observando as regras de cancelamento previstas no site acima ou no\n  aplicativo "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(". ")
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID,")]),
                    _vm._v(
                      " após a rescisão ou cancelamento da sua assinatura,\n  se reserva ao direito de excluir todos os seus dados no curso normal\n  de operação. Seus dados não poderão ser recuperados após o\n  cancelamento de sua conta. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("\n  Os\n  "),
                    _c("b", [_vm._v("USUÁRIO CLIENTES")]),
                    _vm._v(" podem encerrar o uso da "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" a\n  qualquer momento. A "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " também se reserva ao direito de\n  suspender ou encerrar o oferecimento da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " a qualquer\n  momento, a nosso critério e sem aviso prévio. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(" poderá manter e tratar os dados pessoais do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      "\n  durante todo o período em que os mesmos forem pertinentes ao alcance\n  das finalidades listadas neste termo. Dados pessoais anonimizados,\n  sem possibilidade de associação ao indivíduo, poderão ser\n  mantidos por período indefinido."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          background: "#ffffff",
          "text-decoration": "none"
        }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "se reserva ao direito de efetuar o cancelamento de\n  contas dos "
                    ),
                    _c("b", [_vm._v("USUÁRIOS CLIENTES")]),
                    _vm._v(
                      " inativos, por período igual ou\n  maior que 01 (um) ano. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        background: "#ffffff",
        "text-decoration": "none"
      }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          background: "#ffffff",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" poderá solicitar à "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ", a qualquer\n  momento, que sejam eliminados os dados pessoais não anonimizados. O\n  "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" fica ciente de que poderá ser inviável à "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      "\n  continuar o fornecimento de produtos ou serviços ao "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v("\n  a partir da eliminação dos dados pessoais.")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        background: "#ffffff",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-top": "0.28cm",
          "margin-bottom": "0cm",
          "line-height": "100%"
        }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("10.2.\n  USUÁRIO PRESTADOR")])]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-top": "0.28cm",
        "margin-bottom": "0cm",
        "line-height": "100%"
      }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: { "margin-bottom": "0cm", "line-height": "100%" },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Helvetica Neue, serif" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_vm._v("O\n  ")]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("USUÁRIO\n  PRESTADOR")])]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "\n  deve atentar para as regras e valores de cancelamento e remarcações,\n  previstas no site "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c("font", { attrs: { color: "#0000ff" } }, [
                  _c("u", [
                    _c(
                      "a",
                      { attrs: { href: "http://www.donamaid.com/" } },
                      [
                        _c(
                          "font",
                          { attrs: { face: "Arial" } },
                          [
                            _c(
                              "font",
                              {
                                staticStyle: { "font-size": "11pt" },
                                attrs: { size: "2" }
                              },
                              [_vm._v("www.donamaid.com")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_vm._v("\n  e no aplicativo da ")]
                    )
                  ],
                  1
                ),
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [_c("b", [_vm._v("DONAMAID\n  - Quero ser diarista.")])]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        background: "#ffffff",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "page-break-inside": "avoid",
          "text-decoration": "none",
          "page-break-after": "avoid"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("11.\n  DO USO DA IMAGEM:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c("a", { attrs: { name: "_j0zll" } }),
        _vm._v(" "),
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { attrs: { lang: "en-US" } }, [_vm._v("O\n  ")]),
                    _c("span", { attrs: { lang: "en-US" } }, [
                      _c("b", [_vm._v("USUÁRIO")])
                    ]),
                    _c("span", { attrs: { lang: "en-US" } }),
                    _vm._v(" autoriza expressamente à "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _c("b", [_vm._v(", ")]),
                    _vm._v(
                      "sem que nada\n  possa ser reclamado à título de direitos de imagem ou a qualquer\n  outro, a partir do aceite deste termo, a utilização de quaisquer\n  imagens e vozes em todo e qualquer material, entre fotos, imagens e\n  documentos, para ser utilizada em campanhas promocionais e\n  institucionais da "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      ", sejam essas destinadas à\n  divulgação ao público em geral, uso na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " ou uso em\n  ações internas. A presente autorização é concedida a título\n  gratuito, abrangendo o uso da imagem e voz acima mencionada, sem\n  limite de tempo ou número de utilizações, em todo território\n  nacional e no exterior, das seguintes formas: "
                    ),
                    _c("b", [_vm._v("(I)")]),
                    _vm._v(" outdoor;\n  "),
                    _c("b", [_vm._v("(II)")]),
                    _vm._v(
                      " busdoor; folhetos em geral (encartes, mala direta,\n  catálogo, etc.); "
                    ),
                    _c("b", [_vm._v("(III)")]),
                    _vm._v(" folder de apresentação; "),
                    _c("b", [_vm._v("(IV)")]),
                    _vm._v("\n  anúncios em revistas e jornais em geral; "),
                    _c("b", [_vm._v("(V)")]),
                    _vm._v(" home page; "),
                    _c("b", [_vm._v("(VI)")]),
                    _vm._v("\n  cartazes; "),
                    _c("b", [_vm._v("(VII)")]),
                    _vm._v(" back-light; "),
                    _c("b", [_vm._v("(VIII) ")]),
                    _vm._v(
                      "mídia eletrônica\n  (painéis, vídeo-tapes, televisão, cinema, programa para rádio,\n  entre outros) "
                    ),
                    _c("b", [_vm._v("(IX)")]),
                    _vm._v(
                      " Mídias virtuais (Twitter, Instagram,\n  Facebook, Spotify, entre outros); "
                    ),
                    _c("b", [_vm._v("(X)")]),
                    _vm._v(" plataforma "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "page-break-inside": "avoid",
        "text-decoration": "none",
        "page-break-after": "avoid"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "page-break-inside": "avoid",
          "text-decoration": "none",
          "page-break-after": "avoid"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("12.\n  SUPORTE TÉCNICO:")
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c("a", { attrs: { name: "_fob9te" } }),
        _vm._v(" "),
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("A\n  ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  prestará suporte aos ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("USUÁRIOS")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("\n  da ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  nos seguintes horários: De segunda à sexta, das 07h30 até às 20h,\n  e nos sábados, das 8h ao 12h (exceto feriados), através dos\n  telefones informados no website (www.donamaid.com), o e-mail\n  contato@donamaid.com e o link do sistema FreshDesk\n  ("
                      )
                    ]),
                    _c("font", { attrs: { color: "#0000ff" } }, [
                      _c("u", [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://donamaid.freshdesk.com/support/tickets/new"
                              }
                            },
                            [
                              _vm._v(
                                "https://donamaid.freshdesk.com/support/tickets/new"
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(").\n  Nas solicitações de suporte via e-mail, a ")
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("DONAMAID")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "\n  terá até 72 (setenta e duas) horas úteis para proceder à\n  resposta."
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("13.\n  DA POLÍTICA DE PRIVACIDADE:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Os\n  "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      " aceitam e concordam que as informações cadastradas\n  na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " sejam publicadas e/ou fornecidas de acordo com o\n  previsto neste instrumento. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Os\n  "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(" aceitam e concordam que:")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("Os\n    dados coletados e tratados pela ")
                        ]),
                        _c("b", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("DONAMAID\n    ")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v("através da ")
                        ]),
                        _c("b", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("PLATAFORMA\n    ")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "serão armazenados nos\n    servidores de empresa subcontratada "
                          )
                        ]),
                        _c("b", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("HEROKU,")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "\n    cuja sede fica fora do país e que pode ser contatada através do\n    "
                          )
                        ]),
                        _c("i", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("site ")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }),
                        _c(
                          "font",
                          { attrs: { color: "#1155cc" } },
                          [
                            _c("font", { attrs: { face: "Arial" } }, [
                              _c("u", [
                                _c("b", [
                                  _c(
                                    "span",
                                    { staticStyle: { background: "#ffffff" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://help.heroku.com/"
                                          }
                                        },
                                        [_vm._v("https://help.heroku.com/")]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ],
                          1
                        ),
                        _c("b", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v(".")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "\n    Ainda, o armazenamento e tratamento dos dados pela "
                          )
                        ]),
                        _c("b", [
                          _c(
                            "span",
                            { staticStyle: { background: "#ffffff" } },
                            [_vm._v("DONAMAID\n    ")]
                          )
                        ]),
                        _c("span", { staticStyle: { background: "#ffffff" } }, [
                          _vm._v(
                            "perdurará pelo tempo\n    que o cadastro do Usuário se mantiver na Plataforma."
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "Qualquer\n    informação fornecida seja guardada numa base de dados controlada\n    pela "
                        ),
                        _c("b", [_vm._v("DONAMAID")]),
                        _vm._v(";")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "Essa\n    base de dados possa ser armazenada em servidores não localizados no\n    país onde o "
                        ),
                        _c("b", [_vm._v("USUÁRIO")]),
                        _vm._v(" se encontra nem onde a "),
                        _c("b", [_vm._v("DONAMAID ")]),
                        _vm._v("se\n    encontra;")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "p",
          {
            staticStyle: {
              "margin-bottom": "0cm",
              "line-height": "100%",
              "text-decoration": "none"
            },
            attrs: { align: "justify" }
          },
          [
            _c(
              "font",
              { attrs: { color: "#000000" } },
              [
                _c(
                  "font",
                  { attrs: { face: "Arial" } },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "font-size": "11pt" },
                        attrs: { size: "2" }
                      },
                      [
                        _vm._v(
                          "Os\n    servidores sejam de propriedade e administrados por prestadoras de\n    serviço contratados pela "
                        ),
                        _c("b", [_vm._v("DONAMAID.")])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "Ainda\n  que utilizando infraestrutura computacional administrada por\n  terceiros, a "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("não autoriza o uso das informações do\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" pela prestadora de serviço. ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" é nossa. O "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " pode usá-la de acordo\n  com esse Termo de Uso, mas o código-fonte, a marca, os elementos\n  técnicos, de design, de processos, relatórios, e outros que nos\n  ajudam a caracterizar a "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      " são de nossa propriedade e\n  não devem ser usados pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " de nenhuma forma que não\n  seja previamente autorizada por escrito pela "
                    ),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O\n  "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " concorda que não vai fazer, tentar fazer, ou ajudar\n  alguém a fazer nenhum tipo de engenharia reversa ou tentativa de\n  acesso ao código fonte e estrutura do banco de dados, em relação a\n  "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(". Os comentários e sugestões dos "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(
                      "\n  são muito bem-vindos e podem gerar inovações ou implementações\n  que podem ser incorporadas à "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(", mas isso não dará\n  ao "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" nenhuma espécie de direito sobre elas. O "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      "\n  não tem e não terá nenhuma propriedade, titularidade ou\n  participação direta ou indireta na "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" ou na\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("Ainda\n  que a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "escolha as prestadoras de serviço líderes\n  mundiais em segurança de dados, a "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "se exime de\n  responsabilidade por qualquer possível atentado "
                    ),
                    _c("i", [_vm._v("hacker ")]),
                    _vm._v(
                      "ou\n  falha das tecnologias de segurança que possam levar essa informação\n  a ser exposta."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A "),
                    _c("b", [_vm._v("DONAMAID\n  ")]),
                    _vm._v("protege todos os dados pessoais do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " utilizando\n  padrões de cuidado técnica e economicamente razoáveis\n  considerando-se a tecnologia atual da Internet. O "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " reconhece\n  que não pode haver expectativa quanto a segurança total na "
                    ),
                    _c("i", [_vm._v("Internet")]),
                    _vm._v("\n  contra invasão de "),
                    _c("i", [_vm._v("websites")]),
                    _vm._v(" ou outros atos irregulares.")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID")]),
                    _vm._v(
                      " coleta dados pessoais com a finalidade de prestar\n  seus serviços. Somos comprometidos a preservar a privacidade e\n  segurança de nossos usuários, com tal processamento de dados sendo\n  feito em estrita conformidade às leis e regulamentos aplicáveis, em\n  particular com a Lei Geral de Proteção de Dados (LGPD)."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("É\n  reservado o direito da "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("em fornecer os dados e\n  informações do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(", bem como de todo o sistema\n  utilizado na "),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(
                      ", para sua equipe técnica, podendo ser\n  formada por funcionários da "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "e/ou por empresa\n  terceirizada, nos quais serão responsáveis por administrar a\n  segurança e confiabilidade da "
                    ),
                    _c("b", [_vm._v("PLATAFORMA")]),
                    _vm._v(" e dos dados dos\n  "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(".")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        "Todos\n  os integrantes da equipe técnica, sejam funcionários ou empresa\n  terceirizada, firmarão termo de confidencialidade, declarando que se\n  obrigam a manter sob absoluto sigilo todas as informações\n  comerciais, contábeis, administrativas, tecnológicas, infra\n  estruturais, técnicas, ou seja, quaisquer dados revelados mutuamente\n  em decorrência da manutenção do funcionamento e segurança da\n  "
                      )
                    ]),
                    _c("b", [
                      _c("span", { staticStyle: { background: "#ffffff" } }, [
                        _vm._v("PLATAFORMA")
                      ])
                    ]),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v(
                        ",\n  abstendo-se de utilizá-las em proveito próprio ou de terceiros,\n  comprometendo-se a zelar para que seus sócios, funcionários com\n  vínculo empregatício e terceiros de sua confiança, informados\n  dessa obrigação, também o façam.\n  "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "não está autorizada a fornecer os dados cadastrados\n  pelo "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " à terceiros, a não ser nas formas previstas\n  neste instrumento e mediante seu expresso consentimento."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "É\n  de competência exclusiva da Justiça e órgãos legais do território\n  brasileiro requerer fundamentadamente a"
                    ),
                    _c("b", [_vm._v(" DONAMAID ")]),
                    _vm._v("o\n  fornecimento de dados pessoais do "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " que comprovadamente\n  desrespeitar os termos e condições presentes neste instrumento e as\n  disposições legais aplicáveis à espécie, reservando-se a\n  "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "no direito de fornecer à Justiça e órgãos legais\n  competentes os dados pessoais do "
                    ),
                    _c("b", [_vm._v("USUÁRIO,")]),
                    _vm._v(" quando\n  fundamentadamente requeridos.")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_c("b", [_vm._v("13.\n  DAS DISPOSIÇÕES GERAIS:")])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("O "),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(
                      " se\n  obriga a manter atualizados seus dados cadastrais, bem como informar\n  qualquer modificação verificada, especialmente seus dados de\n  pagamento, bem como seu endereço de e-mail e telefone os quais serão\n  os principais canais de comunicação entre a "
                    ),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v("e\n  os "),
                    _c("b", [_vm._v("USUÁRIOS")]),
                    _vm._v(". ")
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v("A\n  "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "poderá alterar este instrumento a qualquer momento,\n  bastando, para tanto, publicarmos uma versão revisada em nosso site.\n  Por este motivo, recomendamos veementemente que sempre visite esta\n  seção de nosso site, lendo, periodicamente. Mas, para contribuir\n  com o bom relacionamento, também enviaremos um e-mail informando\n  acerca dessas mudanças."
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [
                    _vm._v(
                      "O\n  presente instrumento constitui o entendimento integral entre\n  o "
                    ),
                    _c("b", [_vm._v("USUÁRIO")]),
                    _vm._v(" e a "),
                    _c("b", [_vm._v("DONAMAID ")]),
                    _vm._v(
                      "e é regido pelas\n  Leis Brasileiras, ficando eleito "
                    ),
                    _c("span", { staticStyle: { background: "#ffffff" } }, [
                      _vm._v("o\n  foro da cidade de Pelotas - RS")
                    ]),
                    _vm._v(
                      ", como único competente para\n  dirimir questões decorrentes do presente instrumento, com renúncia\n  expressa a qualquer outro foro, por mais privilegiado que seja. "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        }
      },
      [
        _c("a", { attrs: { name: "_GoBack" } }),
        _vm._v(" "),
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_vm._v("Pelotas/RS,\n  08 de outubro de 2020.")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", {
      staticStyle: {
        "margin-bottom": "0cm",
        "line-height": "100%",
        "text-decoration": "none"
      },
      attrs: { align: "justify" }
    }),
    _vm._v(" "),
    _c(
      "p",
      {
        staticStyle: {
          "margin-bottom": "0cm",
          "line-height": "100%",
          "text-decoration": "none"
        },
        attrs: { align: "justify" }
      },
      [
        _c(
          "font",
          { attrs: { color: "#000000" } },
          [
            _c(
              "font",
              { attrs: { face: "Arial" } },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "font-size": "11pt" },
                    attrs: { size: "2" }
                  },
                  [_vm._v("DONAMAID\n  TECNOLOGIA LTDA.")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ee0322", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ee0322","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TermsOfUse/TermsOfUse.vue
// module id = null
// module chunks = 